import { formatDate } from '@/utils/util'
import { enhanceJSListAll } from '@api/online'
import { deleteAction, getAction, postAction } from '@api/manage'
import debounce from 'lodash/debounce'

const onlUtil = {
  data() {
    return {
      // mixin_pca:''
      // 公用JS增强方法
      utilEnhanceJS: {},
      jsFlag: true
    }
  },
  methods:{
    // 获取公用JS方法
    getInitUtilEnhanceJs(callback) {
      if(!this.jsFlag) callback()
      this.jsFlag && enhanceJSListAll().then(res => {
        this.jsFlag = false
        if (!res.result) return callback()
        res.result.forEach(ele => {
          this.utilEnhanceJS[ ele.code ] = this.initUtilEnhanceJs(ele.enjs)
        })
        callback()
      })
    },
    // 初始化JS增强公用方法
    initUtilEnhanceJs(enhanceJs) {
      if (!enhanceJs) return
      let js = `function OnlineEnhanceJs(getAction,postAction,deleteAction,that){
                  return {
                    _getAction: getAction,
                    _postAction: postAction,
                    _deleteAction: deleteAction,
                    that: that,
                    ${enhanceJs}
                  }
                }`
      let utils = eval(`(${js})`)
      return new utils(getAction, postAction, deleteAction, this)
    },
    simpleDateFormat(millisecond, format) {
      return formatDate(millisecond, format)
    },
    getPcaText(code) {
      return this.mixin_pca.getText(code)
    },
    getPcaCode(text) {
      return this.mixin_pca.getCode(text)
    }
  }
}

export { onlUtil }